import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { fetchStateIl, type StateIlResult } from "./hud-il.server";

export type { IlRow, StateIlResult } from "./hud-il.server";

/** Newest stored HUD fiscal year for the state unless a year is requested. */
export const getStateIncomeLimits = createServerFn({ method: "GET" })
  .inputValidator((input: unknown) =>
    z.object({ state: z.string().length(2), year: z.number().int().min(2020).max(2030).optional() }).parse(input),
  )
  .handler(async ({ data }): Promise<StateIlResult> => fetchStateIl(data.state, data.year));
